if(!customElements.get('bis-modal')) {
  class bisModal extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('dialog');
      this.bisForm = this.querySelector('form');
      this.productTitle = this.querySelector('[data-product-title]');
      this.variantName = this.querySelector('[data-product-variant]');
      this.variantId = this.querySelector('[data-bis-variant-id]');
      this.productId = this.querySelector('[data-bis-product-id]');
      this.bisTypeSelectors = this.querySelectorAll('input[type="radio"]');
      this.closeButton = this.querySelector('[data-close-button]');

      this.intlPhoneNumberSelector();
    }

    connectedCallback() {
      document.addEventListener('bisForm:open', this.openModal.bind(this));

      this.bisTypeSelectors.forEach((radio) => {
        radio.addEventListener('change', (evt) => {
          let emailAction = 'remove';
          let smsAction = 'add';
          if(evt.target.value == 'sms') {
            emailAction = 'add';
            smsAction = 'remove';
          }
          this.querySelector('input[type="email"]').classList[emailAction]('hidden');
          this.querySelector('input[type="tel"]').closest('.iti').classList[smsAction]('hidden');
        })
      })

      this.bisForm?.addEventListener('submit', this.submitModal.bind(this));
      this.closeButton.addEventListener('click', this.closeModal.bind(this));
    }

    openModal(evt) {
      const info = evt.detail;

      this.productTitle.innerText = info.productTitle;
      this.variantName.innerText = info.variantTitle;
      this.productId.value = info.productId;
      this.variantId.value = info.variantId;

      this.dialog.showModal();
    }

    closeModal() {
      this.dialog.close();
    }

    intlPhoneNumberSelector() {
      if(!window.intlTelInput) {
        setTimeout(() => {
          this.intlPhoneNumberSelector();
        }, 200)
      } else {
        this.bisPhone = window.intlTelInput(this.querySelector('input[type="tel"]'), {
          initialCountry: Shopify.country,
          containerClass: 'hidden',
          loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
        })
      }
    }

    submitModal(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      const selectedType = Array.from(this.bisTypeSelectors).find((selector) => selector.checked);

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: [],
            profile: {
              data: {
                type: "profile",
                attributes: {
                }
              }
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${this.variantId.value}`
              }
            }
          }
        }
      }

      if(selectedType.value == 'email') {
        const email = this.bisForm.querySelector('input[type="email"').value;

        payload.data.attributes.channels.push('EMAIL')
        payload.data.attributes.profile.data.attributes.email = email;
      } else if(selectedType.value == 'sms') {
        let phone = this.bisPhone.getNumber();

        payload.data.attributes.channels.push("SMS");
        payload.data.attributes.profile.data.attributes.phone_number = phone;
      }

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=KkSJyW', {
        headers: {
          "accept": "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
          "revision": "2025-04-15",
        },
        method: "post",
        body: JSON.stringify(payload)
      }).then(async (data) => {
        if(data.status == "202") {
          const confirmMessage = this.querySelector('[data-confirm-message]');
          confirmMessage.innerText = 'We\'ll Notify You When It\'s Back In Stock';
          confirmMessage.parentElement.removeAttribute('hidden');
          setTimeout(() => {
            confirmMessage.parentElement.setAttribute("hidden", "true");
          }, 3000);
        } else {
          const confirmMessage = this.querySelector('[data-confirm-message]');
          const sucessIcon = this.querySelector('.bis-modal-form__confirm-message svg');
          const response = await data.json();
          const errorsMsg = await response.errors.map((error) => {
            return error.detail;
          })

          sucessIcon.style.display = "none";
          confirmMessage.innerHTML = errorsMsg.join('<br/>');
          confirmMessage.parentElement.removeAttribute('hidden');

          setTimeout(() => {
            confirmMessage.parentElement.setAttribute("hidden", "true");
            sucessIcon.removeAttribute("style");
          }, 5000);
        }
      })
    }
  }

  customElements.define('bis-modal', bisModal);
}